import { useLocation } from 'react-router-dom';
import queryString from "qs"
const useQuery = () => queryString.parse(useLocation().search.slice(1));

export default useQuery



// WEBPACK FOOTER //
// ./src/useQuery.js